
import React, { useCallback, useEffect, useState } from "react";

import Joyride, { CallBackProps, STATUS, Step } from 'react-joyride';
import { useNavigate } from "react-router-dom";

import { storedEnv } from '../../utils/localStorage'
import { onDisabledScrollHandler, onEnableScrollHandler } from '../../utils/ScrollHandler';
import { useMount, useSetState } from "react-use";
import useUser from "../../hooks/UserContext";
import MaisConteudoAPi from "../../services/MaisConteudoAPi";

interface State {
  run: boolean;
  stepIndex: number;
  steps: Step[];
}

const Tutorial: React.FC = () => {
  const { userInfo, isLogged } = useUser()
  const navigate = useNavigate();
  const [checkTutorial, setCheckTutorial] = useState(false)

  const [{ run, steps }, setState] = useSetState<State>({
    run: false,
    stepIndex: 0,
    steps: [],
  });

  const widthWindow = () => {
    let width = window.innerWidth || document.body.clientWidth;
    if (width <= 768) return ".nav__mobile--container .a__navlink--disabled"
    if (width > 768) return "header .a__navlink--disabled"
  }

  useMount(() => {
    setState({
      steps: [
        {
          target: '.home',
          title: (<>Bem vindo ao +Lojinha!</>),
          content: (<>Você chegou ao seu primeiro passo para impulsionar suas vendas. <br /> Então vamos lá!</>),
          locale: { skip: 'Pular', next: 'Próximo' },
          placement: 'center',
          disableBeacon: true,
          disableOverlay: false,
          disableOverlayClose: true,
          isFixed: true,
        },
        {
          target: '.SearchButton',
          title: (<>Busca direcionada</>),
          content: "Possibilidade de buscar por um produto específico através do nome, código de referência ou link da peça no site.",
          locale: { skip: 'Pular', back: 'Voltar', next: 'Próximo' },
          placement: 'bottom',
          disableOverlay: false,
          disableOverlayClose: true,
          isFixed: true,
          disableBeacon: true,
        },
        {
          target: '.svg__zoom',
          title: (<>Produtos</>),
          content: "Compartilhe o link da peça desejada já com seu código na mochila. ",
          locale: { skip: 'Pular', back: 'Voltar', next: 'Próximo' },
          placement: 'bottom',
          disableOverlay: false,
          disableOverlayClose: true,
          isFixed: true,
          disableBeacon: true

        },
        {
          target: ".btn__footerbtn--button ",
          title: (<>Criar lojinhas</>),
          content: "Aumente o alcançe de itens por pessoas criando e compartilhando lojinhas de acordo com seu estilo.",
          locale: { skip: 'Pular', back: 'Voltar', next: 'Próximo' },
          disableOverlay: false,
          disableOverlayClose: true,
          isFixed: true,
        },
        {
          target: widthWindow(),
          title: (<>Lojinhas</>),
          content: "Acompanhe ou edite suas lojinhas e descubra a quantidade de acessos e vendas por lojinha! Não é incrível? ",
          locale: { back: 'Voltar', last: 'Finalizar' },
          disableOverlay: false,
          disableOverlayClose: true,
          isFixed: true,
        },
      ] as Step[],
    });

  });

  const onCloseTutorialHandler = useCallback(() => { setState({ run: false, stepIndex: 0, steps: [] }); }, [setState])

  const handleCallback = useCallback(async (data: CallBackProps) => {
    const { status } = data;
    if (([STATUS.FINISHED, STATUS.SKIPPED] as string[]).includes(status)) {
      setCheckTutorial(true)
    }
  }, [])

  const onOpenTutorialMemo = useCallback(async () => {
    if (isLogged) {
      try {
        const res = await MaisConteudoAPi.get('/v1/tutorial')
        if (res.data === 0) {
          setState({
            run: true,
          });
        }
      }
      catch (error: any) {
        console.log(error.response?.data.message)
      }
    }
  }, [setState, isLogged])

  const onCheckTutorialMemo = useCallback(async () => {

    try {
      await MaisConteudoAPi.post('/v1/tutorial',
        {
          code: userInfo.code,
        });
      onCloseTutorialHandler()
      navigate('/my-wishlists')
    } catch (error: any) {
      console.log(error.response?.data.message)
    }
  }, [onCloseTutorialHandler, navigate, userInfo.code])

  useEffect(() => {
    if (storedEnv !== 'null' && !!storedEnv) {
      onOpenTutorialMemo()
    }
  }, [onOpenTutorialMemo, isLogged])

  useEffect(() => {
    if (checkTutorial) {
      onCheckTutorialMemo()
    }
  }, [checkTutorial, onCheckTutorialMemo]);

  useEffect(() => {
    if (run) {
      onDisabledScrollHandler()
    } else onEnableScrollHandler()
  }, [run]);

  return (
    <>
      <Joyride
        steps={steps}
        run={run}
        continuous={true}
        showSkipButton
        showProgress
        hideCloseButton={true}
        callback={handleCallback}
        styles={{
          options: {
            arrowColor: "#DBC7B8",
            primaryColor: "#424242",
            textColor: "#424242",
            backgroundColor: "#DBC7B8"
          },
        }}
      />
    </>

  );
};

export default Tutorial;

